/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { Formik, Form } from "formik";
import {
  createprivateClass,
  getAgeGroup,
  getClassesWithoutPagination,
  getCoupons,
  getDaysPerWeekbyId,
  getLevels,
} from "../Services/Service";
import DropDown from "../Components/DropDown";
import moment from "moment";
import { DayPicker } from "react-day-picker";

export default function CheckoutModal(props) {
  const [ageGroup, setageGroup] = useState([]);
  const [selectedAge, setselectedAge] = useState("");
  const [selectedCoupon, setselectedCoupon] = useState("");
  const [levels, setlevels] = useState([]);
  const [levelSelected, setlevelSelected] = useState("");
  const [classes, setclasses] = useState([]);
  const [country, setcountry] = useState({});
  const [startDate, setStartDate] = useState("");
  const [coupons, setcoupons] = useState([]);
  const [calendarClick, setcalendarClick] = useState(false);
  const [daysPerWeeks, setdaysPerWeeks] = useState({});
  const [skillsToImprove, setskillsToImprove] = useState([]);
  const [timingSelected, settimingSelected] = useState([]);
  const [generatedLink, setgeneratedLink] = useState("");
  const [selectedDays, setselectedDays] = useState([
    { day: "sat", key: 6, status: false },
    { day: "sun", key: 0, status: false },
    { day: "mon", key: 1, status: false },
    { day: "tue", key: 2, status: false },
    { day: "wed", key: 3, status: false },
    { day: "thu", key: 4, status: false },
    { day: "fri", key: 5, status: false },
  ]);

  useEffect(() => {
    async function fetchData() {
      // You can await hereby
      const ageGroup = await getAgeGroup();
      const levels = await getLevels();
      const classes = await getClassesWithoutPagination();
      const daysperweek = await getDaysPerWeekbyId(
        props.selectedOpt.daysPerWeek
      );
      const coupons = await getCoupons();

      setcoupons(coupons);
      setdaysPerWeeks(daysperweek);
      setcountry(country);
      setclasses(classes);
      setlevels(levels);
      setageGroup(ageGroup);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let levelsArrayKids = levels.filter((a, key) => {
    if (key === 0 || key === 4 || key === 7) {
      return {
        ...a,
      };
    }
  });
  // console.log(timingSelected);
  const classesArray = classes
    .filter((op) => {
      return props.selectedOpt.course === op.course;
    })
    .filter((op) => {
      return op.private === false;
    })
    .filter((op) => {
      return selectedAge.id === op.optionAge;
    })
    .filter((op) => {
      return op.level.indexOf(levelSelected.id) !== -1;
    })
    .filter(() => {
      return props.selectedOpt.type === "6124bf6f703f370d8cbf2c11";
    })
    .filter((op) => {
      return op.status === true;
    })
    .filter((op) => {
      if (props.selectedOpt.daysPerWeek === "612de0e5c00f8306c5a96ba5") {
        return op.daysPerWeek === props.selectedOpt.daysPerWeek;
      }
      if (props.selectedOpt.daysPerWeek === "612de0d0c00f8306c5a96ba4") {
        return (
          op.daysPerWeek === props.selectedOpt.daysPerWeek ||
          op.daysPerWeek === "612de0e5c00f8306c5a96ba5"
        );
      }
      return op.daysPerWeek;
    });

  const sortByTimeAsc = function (lhs, rhs) {
    // eslint-disable-next-line no-shadow
    let results;

    results =
      new Date(lhs.time).getHours() > new Date(rhs.time).getHours()
        ? 1
        : new Date(lhs.time).getHours() < new Date(rhs.time).getHours()
        ? -1
        : 0;

    if (results === 0)
      results =
        new Date(lhs.time).getMinutes() > new Date(rhs.time).getMinutes()
          ? 1
          : new Date(lhs.time).getMinutes() < new Date(rhs.time).getMinutes()
          ? -1
          : 0;

    if (results === 0)
      results =
        new Date(lhs.time).getSeconds() > new Date(rhs.time).getSeconds()
          ? 1
          : new Date(lhs.time).getSeconds() < new Date(rhs.time).getSeconds()
          ? -1
          : 0;

    return results;
  };

  const TimingArray = [
    { time: moment("9:00 AM", "HH:mm"), id: 1 },
    { time: moment("10:00 AM", "HH:mm"), id: 2 },
    { time: moment("11:00 AM", "HH:mm"), id: 3 },
    { time: moment("12:00 PM", "HH:mm"), id: 4 },
    { time: moment("13:00 PM", "HH:mm"), id: 5 },
    { time: moment("14:00 PM", "HH:mm"), id: 6 },
    { time: moment("15:00 PM", "HH:mm"), id: 7 },
    { time: moment("16:00 PM", "HH:mm"), id: 8 },
    { time: moment("17:00 PM", "HH:mm"), id: 9 },
    { time: moment("18:00 PM", "HH:mm"), id: 10 },
  ];

  const today = new Date();

  const disableDays = selectedDays.map((a) =>
    a.status === false ? a.key : null
  );

  const tomorrow = moment().add(1, "days").toDate();
  const onClickSkills = (a) => {
    if (skillsToImprove.includes(a)) {
      const filter = skillsToImprove.filter((x) => x !== a);
      setskillsToImprove(filter);
    } else {
      setskillsToImprove([...skillsToImprove, a]);
    }
  };

  return (
    <div>
      <Modal show={props.show} onHide={props.onHide} size="xl">
        <Formik
          enableReinitialize={true}
          initialValues={{
            name: "",
            email: "",
          }}
          // validationSchema={Yup.object({
          //   //   email: Yup.string().required("Enter Email"),
          // })}
          onSubmit={async (values, { setSubmitting }) => {
            const selectedCon =
              props.selectedCurrency2.name === "KWD"
                ? "kw"
                : props.selectedCurrency2.name === "SAR"
                ? "sa"
                : props.selectedCurrency2.name === "AED"
                ? "ae"
                : props.selectedCurrency2.name === "BHD"
                ? "ba"
                : props.selectedCurrency2.name === "OMR"
                ? "om"
                : props.selectedCurrency2.name === "QAR"
                ? "qa"
                : "";
            if (startDate) {
              if (props.selectedType.slug === "private") {
                let availableDays = selectedDays.filter(
                  (a) => a.status === true
                );

                let cls = await createprivateClass({
                  optionAge: selectedAge.id,
                  optionAgeName: selectedAge.name,
                  level: [levelSelected.id],
                  course: props.selectedOpt.course,
                  courseName: props.courseSelected.slug,
                  partner: "619b9774d8e0f810ebf0c7d5",
                  partnerName: "ulearn",
                  zoomLink: "https://zoom.us/",
                  zoomPassword: "test",
                  time: moment(timingSelected.time).format(),
                  status: true,
                  availableDays: availableDays.map((a) => a.day),
                  daysPerWeek: daysPerWeeks.id,
                  private: true,
                });
                const link = `https://staging.ulearn.study/${selectedCon}/checkout2?classId=${
                  cls.id
                }&optId=${props.selectedOpt.id}&cpnId=${
                  selectedCoupon ? selectedCoupon.id : ""
                }&lvlId=${levelSelected.id}&startDate=${moment(
                  startDate
                ).format("yyyy-MM-DD")}&skills=${skillsToImprove
                  .join(",")
                  .toString()}&private=true`;

                setgeneratedLink(link);
              } else {
                const link = `https://staging.ulearn.study/${selectedCon}/checkout2?classId=${
                  timingSelected.id
                }&optId=${props.selectedOpt.id}&cpnId=${
                  selectedCoupon ? selectedCoupon.id : ""
                }&lvlId=${levelSelected.id}&startDate=${moment(
                  startDate
                ).format("yyyy-MM-DD")}&selectedDays=${selectedDays
                  .filter((a) => a.status === true)
                  .map((b) => b.day)
                  .join(",")
                  .toString()}&private=false&skills=`;
                setgeneratedLink(link);
              }
            } else {
              alert("Select all options");
            }
          }}
        >
          <Form>
            <Modal.Header closeButton>
              <Modal.Title>Create checkout link</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {!generatedLink ? (
                <Col md={8}>
                  <Row>
                    <Col md={4}>
                      <DropDown
                        data={ageGroup}
                        toggleClass
                        onClick={async (a) => {
                          setselectedAge(a);
                          settimingSelected({});
                        }}
                        menuStyle={{ height: 114 }}
                        name={!selectedAge ? "Select Age" : selectedAge.name}
                      />
                    </Col>
                    {selectedAge ? (
                      <Col md={4}>
                        <DropDown
                          data={
                            selectedAge.slug === "adults"
                              ? levels
                              : selectedAge.slug === "kids" ||
                                selectedAge.slug === "teens"
                              ? levelsArrayKids
                              : []
                          }
                          toggleClass
                          onClick={async (a) => {
                            setlevelSelected(a);
                            settimingSelected({});
                          }}
                          menuStyle={{ height: 114 }}
                          name={
                            !levelSelected ? "Select Level" : levelSelected.name
                          }
                        />
                      </Col>
                    ) : null}
                    {levelSelected && selectedAge ? (
                      <div style={style.label}>Select Time</div>
                    ) : null}
                    {!classesArray.length && levelSelected && selectedAge ? (
                      <div className="d-flex flex-row flex-wrap w-100">
                        {TimingArray.sort(sortByTimeAsc).map((a) => {
                          const actTime = moment.tz(
                            moment(a.time).format("HH:mm"),
                            "HH:mm",
                            "Europe/London"
                          );

                          const kuwaitTime = actTime
                            .clone()
                            .tz(
                              props.selectedCurrency2.name === "AED"
                                ? "Asia/Dubai"
                                : props.selectedCurrency2.name === "OMR"
                                ? "Asia/Muscat"
                                : "Asia/Kuwait"
                            );

                          return (
                            <div
                              style={{
                                ...style.timeCon,

                                border:
                                  timingSelected.id === a.id
                                    ? "1px solid #299CF7"
                                    : "",
                                background:
                                  timingSelected.id === a.id
                                    ? "#F8FBFE"
                                    : "#fff",
                                position: "relative",
                              }}
                              onClick={async () => {
                                settimingSelected(a);
                                setselectedDays([
                                  { day: "sat", key: 6, status: false },
                                  { day: "sun", key: 0, status: false },
                                  { day: "mon", key: 1, status: false },
                                  { day: "tue", key: 2, status: false },
                                  { day: "wed", key: 3, status: false },
                                  { day: "thu", key: 4, status: false },
                                  { day: "fri", key: 5, status: false },
                                ]);
                              }}
                            >
                              <div style={style.timeText}>
                                {kuwaitTime.format("hh:mm a")}
                              </div>
                              <input
                                type="checkbox"
                                id="customCheckbox2"
                                name="customCheck"
                                className="custom-control-input"
                                checked={timingSelected.id === a.id}
                              />
                              <label className="custom-control-label"></label>
                            </div>
                          );
                        })}
                      </div>
                    ) : classesArray.length && levelSelected && selectedAge ? (
                      <div className="d-flex flex-row flex-wrap w-100">
                        {classesArray.sort(sortByTimeAsc).map((a) => {
                          const actTime = moment.tz(
                            moment(a.time).format("HH:mm"),
                            "HH:mm",
                            "Europe/London"
                          );

                          const kuwaitTime = actTime
                            .clone()
                            .tz(
                              props.selectedCurrency2.name === "AED"
                                ? "Asia/Dubai"
                                : props.selectedCurrency2.name === "OMR"
                                ? "Asia/Muscat"
                                : "Asia/Kuwait"
                            );

                          return (
                            <div
                              style={{
                                ...style.timeCon,
                                border:
                                  timingSelected.id === a.id
                                    ? "1px solid #299CF7"
                                    : "",
                                background:
                                  timingSelected.id === a.id
                                    ? "#F8FBFE"
                                    : "#fff",
                                position: "relative",
                              }}
                              onClick={async () => {
                                settimingSelected(a);
                                setselectedDays([
                                  { day: "sat", key: 6, status: false },
                                  { day: "sun", key: 0, status: false },
                                  { day: "mon", key: 1, status: false },
                                  { day: "tue", key: 2, status: false },
                                  { day: "wed", key: 3, status: false },
                                  { day: "thu", key: 4, status: false },
                                  { day: "fri", key: 5, status: false },
                                ]);
                              }}
                            >
                              <div style={style.timeText}>
                                {kuwaitTime.format("hh:mm a")}
                              </div>
                              <input
                                type="checkbox"
                                id="customCheckbox2"
                                name="customCheck"
                                className="custom-control-input"
                                checked={timingSelected.id === a.id}
                              />
                              <label className="custom-control-label"></label>
                            </div>
                          );
                        })}
                      </div>
                    ) : null}

                    <div>
                      {levelSelected && selectedAge ? (
                        <div style={style.label}>Select days</div>
                      ) : null}
                      {classesArray.length && levelSelected && selectedAge ? (
                        <div className="d-flex flex-wrap flex-row">
                          {selectedDays.map((a) => (
                            <div
                              style={{
                                width: 70,
                                marginRight: 10,
                                height: 30,
                                borderRadius: 8,
                                padding: 5,
                                border: timingSelected.availableDays?.includes(
                                  a.day
                                )
                                  ? "1px solid #299CF7"
                                  : "1px solid #EBEBF0",
                                background:
                                  a.status === true ? "#F8FBFE" : "#fff",
                              }}
                            >
                              <div
                                className="d-flex flex-row"
                                onClick={async () => {
                                  if (
                                    timingSelected &&
                                    timingSelected?.availableDays?.includes(
                                      a.day
                                    ) &&
                                    a.status === false &&
                                    selectedDays.filter((z) => {
                                      return z.status === true;
                                    }).length < daysPerWeeks.daysPerWeek
                                  ) {
                                    const data = selectedDays.map((x) => {
                                      if (x.key === a.key) {
                                        x.status = true;
                                      }
                                      return x;
                                    });

                                    setselectedDays(data);
                                  } else {
                                    const data = selectedDays.map((x) => {
                                      if (x.key === a.key) {
                                        x.status = false;
                                      }
                                      return x;
                                    });
                                    setselectedDays(data);
                                  }
                                }}
                                style={{
                                  opacity:
                                    timingSelected.availableDays?.includes(
                                      a.day
                                    )
                                      ? "1"
                                      : "0.5",
                                }}
                              >
                                <div style={style.daysText}>{a.day}</div>
                                <input
                                  type="checkbox"
                                  id="customCheckbox2"
                                  name="customCheck"
                                  // className="custom-control-input"
                                  checked={a.status === true}
                                />
                                <label className="custom-control-label"></label>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : !classesArray.length &&
                        levelSelected &&
                        selectedAge ? (
                        <div className="d-flex flex-wrap flex-row">
                          {selectedDays.map((a) => (
                            <div
                              style={{
                                width: 70,
                                marginRight: 10,
                                height: 30,
                                borderRadius: 8,
                                padding: 5,
                                border: timingSelected
                                  ? "1px solid #299CF7"
                                  : "1px solid #EBEBF0",
                                background:
                                  a.status === true ? "#F8FBFE" : "#fff",
                              }}
                            >
                              <div
                                onClick={async () => {
                                  if (
                                    a.status === false &&
                                    selectedDays.filter((z) => {
                                      return z.status === true;
                                    }).length < daysPerWeeks.daysPerWeek
                                  ) {
                                    const data = selectedDays.map((x) => {
                                      if (x.key === a.key) {
                                        x.status = true;
                                      }
                                      return x;
                                    });

                                    setselectedDays(data);
                                  } else {
                                    const data = selectedDays.map((x) => {
                                      if (x.key === a.key) {
                                        x.status = false;
                                      }
                                      return x;
                                    });
                                    setselectedDays(data);
                                  }
                                }}
                                className="custom-control custom-checkbox d-flex flex-row"
                                style={{
                                  textTransform: "uppercase",
                                  fontSize: 12,
                                }}
                              >
                                <div style={style.daysText}> {a.day}</div>
                                <input
                                  type="checkbox"
                                  id="customCheckbox2"
                                  name="customCheck"
                                  // className="custom-control-input"
                                  checked={a.status === true}
                                />
                                <label
                                  className={"custom-control-label"}
                                ></label>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : null}
                    </div>
                    {selectedDays.filter((z) => {
                      return z.status === true;
                    }).length === daysPerWeeks.daysPerWeek ? (
                      <>
                        <div className="col-md-4" style={{ margin: "40px 0" }}>
                          <div
                            className="dd-text d-flex align-items-center"
                            style={style.startDateInput}
                            onClick={() => setcalendarClick(!calendarClick)}
                          >
                            {!startDate
                              ? "Select start date"
                              : moment(startDate).format("DD/MM/YYYY")}
                          </div>
                          {calendarClick ? (
                            <DayPicker
                              selectedDays={startDate}
                              // overlayComponent={CustomOverlay}
                              onDayClick={(date, { selected, disabled }) => {
                                // setdateErr();
                                if (disabled) {
                                  // Day is disabled, do nothing
                                  return;
                                }
                                if (selected) {
                                  // Unselect the day if already selected
                                  setStartDate(undefined);
                                  return;
                                }
                                setStartDate(date);
                                setcalendarClick(false);
                                // console.log.*$
                              }}
                              disabledDays={[
                                {
                                  daysOfWeek: [...disableDays],
                                },
                                {
                                  before: today,
                                },
                                // {
                                //     after: today,
                                // },
                                today,
                                tomorrow,
                              ]}
                            />
                          ) : null}
                        </div>
                        <div style={{ margin: "0 0 40px 0" }}>
                          <DropDown
                            data={coupons}
                            toggleClass
                            onClick={async (a) => {
                              setselectedCoupon(a);
                            }}
                            menuStyle={{ height: 114 }}
                            name={
                              !selectedCoupon
                                ? "Select a coupon"
                                : selectedCoupon.name
                            }
                          />
                        </div>
                        {props.selectedType.slug === "private" ? (
                          <div>
                            <div
                              style={{ marginBottom: 20 }}
                              className="d-flex flex-row justify-content-between flex-wrap"
                            >
                              <div style={{ position: "relative" }}>
                                <div
                                  style={{
                                    border: skillsToImprove.includes("writing")
                                      ? "1px solid #299CF7"
                                      : "1px solid #EBEBF0",
                                    background: skillsToImprove.includes(
                                      "writing"
                                    )
                                      ? "#F8FBFE"
                                      : "#fff",
                                    padding: 5,
                                    borderRadius: 8,
                                  }}
                                  onClick={() => onClickSkills("writing")}
                                >
                                  writing
                                </div>
                              </div>
                              <div style={{ position: "relative" }}>
                                <div
                                  style={{
                                    border: skillsToImprove.includes("reading")
                                      ? "1px solid #299CF7"
                                      : "1px solid #EBEBF0",
                                    background: skillsToImprove.includes(
                                      "reading"
                                    )
                                      ? "#F8FBFE"
                                      : "#fff",
                                    padding: 5,
                                    borderRadius: 8,
                                  }}
                                  onClick={() => onClickSkills("reading")}
                                >
                                  reading
                                </div>
                              </div>
                              <div style={{ position: "relative" }}>
                                <div
                                  style={{
                                    border: skillsToImprove.includes("speaking")
                                      ? "1px solid #299CF7"
                                      : "1px solid #EBEBF0",
                                    background: skillsToImprove.includes(
                                      "speaking"
                                    )
                                      ? "#F8FBFE"
                                      : "#fff",
                                    padding: 5,
                                    borderRadius: 8,
                                  }}
                                  onClick={() => onClickSkills("speaking")}
                                >
                                  talking
                                </div>
                              </div>
                              <div style={{ position: "relative" }}>
                                <div
                                  style={{
                                    border: skillsToImprove.includes("grammar")
                                      ? "1px solid #299CF7"
                                      : "1px solid #EBEBF0",
                                    background: skillsToImprove.includes(
                                      "grammar"
                                    )
                                      ? "#F8FBFE"
                                      : "#fff",
                                    padding: 5,
                                    borderRadius: 8,
                                  }}
                                  onClick={() => onClickSkills("grammar")}
                                >
                                  grammar
                                </div>
                              </div>
                            </div>
                            <div style={{ width: "100%" }}>
                              <div style={{ position: "relative" }}>
                                <div
                                  onClick={() => {
                                    setskillsToImprove([]);
                                    if (
                                      skillsToImprove.includes(
                                        "grammar",
                                        "speaking",
                                        "reading",
                                        "writing"
                                      )
                                    ) {
                                      setskillsToImprove([]);
                                    } else {
                                      setskillsToImprove([
                                        "grammar",
                                        "speaking",
                                        "reading",
                                        "writing",
                                      ]);
                                    }
                                  }}
                                  style={{
                                    border:
                                      skillsToImprove.includes(
                                        "grammar" &&
                                          "speaking" &&
                                          "reading" &&
                                          "writing"
                                      ) && skillsToImprove.length === 4
                                        ? "1px solid #299CF7"
                                        : "1px solid #EBEBF0",
                                    background:
                                      skillsToImprove.includes(
                                        "grammar" &&
                                          "speaking" &&
                                          "reading" &&
                                          "writing"
                                      ) && skillsToImprove.length === 4
                                        ? "#F8FBFE"
                                        : "#fff",
                                    width: "100%",
                                    padding: 5,
                                    borderRadius: 8,
                                  }}
                                >
                                  all the above
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                      </>
                    ) : null}
                    <Button
                      style={{ width: "max-content", margin: "20px 15px" }}
                      type="submit"
                    >
                      Generate Link
                    </Button>
                  </Row>
                </Col>
              ) : (
                // eslint-disable-next-line react/jsx-no-target-blank
                <div className="d-flex flex-row justify-content-around">
                  <a target="_blank" href={generatedLink}>
                    Checkout Link
                  </a>
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      navigator.clipboard.writeText(generatedLink).then(
                        function () {
                          alert(" Copying to clipboard was successful!");
                        },
                        function (err) {
                          console.error("Async: Could not copy text: ", err);
                        }
                      );
                    }}
                  >
                    Click to copy link
                  </div>
                </div>
              )}
            </Modal.Body>
          </Form>
        </Formik>
      </Modal>
    </div>
  );
}

const style = {
  btn: {
    width: 87,
    height: 52,
    background: "#299CF7",
    borderRadius: 4,
    border: "none",
  },
  label: {
    fontFamily: "Cairo",
    fontSize: 16,
    margin: "30px 0 10px 0",
    lineHeight: "20px",
    fontStyle: "normal",
    fontWeight: "bold",
    color: "#000",
  },
  permission: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 18,
    color: "#333333",
  },
  text: {
    fontFamily: "Cairo",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: 21,
    color: "#333333",
  },
  subtext: {
    fontFamily: "Cairo",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: 16,
    color: "#333333",
  },
  header: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 21,
    color: "#333333",
  },
  startDateInput: {
    width: "100%",
    height: "35px",
    padding: 5,
    background: "#fff",
    borderRadius: 8,
  },
  daysText: {
    fontFamily: "Cairo",
    fontSize: 12,
    lineHeight: "20px",
    fontStyle: "normal",
    fontWeight: "bold",
    color: "rgba(30, 36, 50, 0.5)",
    position: "relative",
    paddingRight: 20,
    top: 2,
  },
  timeCon: {
    width: 100,
    marginTop: 10,
    marginRight: 10,
    height: 30,
    borderRadius: 8,
    padding: 5,
  },
  timeText: {
    fontFamily: "Cairo",
    fontSize: 12,
    lineHeight: "20px",
    fontStyle: "normal",
    fontWeight: "bold",
    color: "rgba(30, 36, 50, 0.5)",
  },
};
